module.exports = __webpack_public_path__ + "img/manghe.9dc83559.png";